package org.chiangmeng.qfast.core.presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.launch
import org.chiangmeng.qfast.core.domain.usecases.IssueTicketUseCase
import org.chiangmeng.qfast.core.domain.usecases.NextQueueUseCase
import org.chiangmeng.qfast.core.domain.usecases.ObserveActiveQueuesUseCase
import org.chiangmeng.qfast.core.domain.usecases.ObserveShopUseCase
import org.chiangmeng.qfast.core.domain.usecases.ResetQueueUseCase

class QueueViewModel(
    private val observeShopUseCase: ObserveShopUseCase,
    private val observeActiveQueuesUseCase: ObserveActiveQueuesUseCase,
    private val nextQueueUseCase: NextQueueUseCase,
    private val issueTicketUseCase: IssueTicketUseCase,
    private val resetQueueUseCase: ResetQueueUseCase
) : ViewModel() {

    private val _uiState = MutableStateFlow(QueueUiState())
    val uiState: StateFlow<QueueUiState> = _uiState.asStateFlow()

    fun loadShopData(shopId: String) {
        viewModelScope.launch {
            combine(
                observeShopUseCase(shopId),
                observeActiveQueuesUseCase(shopId)
            ) { shop, queues ->
                QueueUiState(
                    shop = shop,
                    activeQueues = queues,
                    isLoading = false
                )
            }.catch { error ->
                _uiState.value = QueueUiState(
                    isLoading = false,
                    errorMessage = error.message ?: "Unknown Error"
                )
            }.collect { state ->
                _uiState.value = state
            }
        }
    }

    fun nextQueue(shopId: String, category: String) {
        viewModelScope.launch {
            nextQueueUseCase(shopId, category)
        }
    }

    fun issueTicket(shopId: String, category: String) {
        viewModelScope.launch {
            issueTicketUseCase(shopId, category)
        }
    }

    fun resetQueue(shopId: String) {
        viewModelScope.launch {
            resetQueueUseCase(shopId)
        }
    }
}
